import { render, staticRenderFns } from "./InputTipoDocumento.vue?vue&type=template&id=5e310a0a&"
import script from "./InputTipoDocumento.vue?vue&type=script&lang=ts&"
export * from "./InputTipoDocumento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports